module.exports = __webpack_public_path__ + "static/media/Generic.4b5ce899.svg";